<template>
  <b-row>
    <b-col cols="12" class="d-flex align-items-center justify-content-between">
      <PageTitle title="Enviar notificações pelo whatsapp" />
    </b-col>

    <b-col cols="12 mt-4" v-if="loading == false">
      <b-row>
        <b-col cols="6 text-center">
          <h4>Conectar WhatsApp Admin</h4>
          <button class="btn btn-success btn-block mt-2" :disabled="reload" v-if="whatsapp == false" @click="upCode()">
            {{reload == true ? 'Conectando...' : 'Ativar WhatsApp'}}
          </button>
          <button class="btn btn-danger btn-block" v-if="whatsapp == true" @click="delWhats()">Desativar WhatsApp</button>
        </b-col>
        <b-col cols="6 text-center">
          <h4 v-if="qrCode != ''">QR-Code para conectar WhatsApp</h4>
          <img v-if="qrCode != ''" :src="qrCode" alt="Qr-code">

          <div class="alert alert-warning btn-pisca mt-3" role="alert" v-if="reload == true">
            Aguardando leitura do QR-Code!
          </div>

          <div class="alert alert-success mt-4" role="alert" v-if="connect == true">
            Seu WhatsApp está conectado!
          </div>

          <div class="alert alert-danger mt-4" role="alert" v-if="connect == false && reload == false">
            Seu WhatsApp está desconectado!
          </div>

        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions } from 'vuex';
import PageTitle from 'Components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';

export default {
  name: 'WhatsAppAdmin',
  mixins: [makeToast],

  components: {
    PageTitle
  },

  data() {
    return {
      loading: false,
      id: '123',
      whatsapp: false,
      qrCode: '',
      reload: false,
      connect: false,
      search: false,
      i: 1
    };
  },

  watch: {
    'search': function() {
      if(this.connect == false) {
        setTimeout(() => {
          this.infoWhats();
        }, 3000);
      }
    }
  },

  created() {
    this.conectWhats();
  },

  methods: {
    ...mapActions('shopkeeper', [
      'getNotificationWhatsApp',
      'newNotificationWhatsApp',
      'delNotificationWhatsAppAdmin',
      'upNotificationWhatsApp',
      'initNotificationWhatsApp',
      'infoNotificationWhatsApp'
    ]),
    upCode() {
      this.loading = true;
      this.$store.dispatch('startLoader');
      this.initNotificationWhatsApp(this.id)
        .then(() => {
          this.upCodeInit();
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    upCodeInit() {
      this.loading = true;
      this.$store.dispatch('startLoader');
      this.upNotificationWhatsApp(this.id)
        .then((response) => {
          if(response.data.qrCode && response.data.qrCode != '') {
            this.qrCode = response.data.qrCode;
            this.reload = true;
            this.search = !this.search;
          } else {
            if(this.i == 5) {
              this.makeToast('Opss', 'Houve um erro ao gerar QR-Code, tente novamente!', 'danger');
            } else {
              this.i = this.i + 1;
              this.upCode();
            }
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao gerar QR-Code!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    infoWhats() {
      this.infoNotificationWhatsApp(this.id)
        .then((response) => {
          if(response.data.instance_data && response.data.instance_data.phone_connected && response.data.instance_data.phone_connected == true) {
            this.connect = true;
            this.whatsapp = true;
            this.reload = false;
            this.qrCode = '';
          } else {
            this.search = !this.search;
          }
        });
    },
    conectWhats() {
      this.infoNotificationWhatsApp(this.id)
        .then((response) => {
          if(response.data.instance_data && response.data.instance_data.phone_connected && response.data.instance_data.phone_connected == true) {
            this.connect = true;
            this.whatsapp = true;
            this.reload = false;
            this.qrCode = '';
          }
        });
    },
    delWhats() {
      this.loading = true;
      this.$store.dispatch('startLoader');
      this.delNotificationWhatsAppAdmin(this.id)
        .then((response) => {
          if(response.data.status && response.data.status == true) {
            this.whatsapp = false;
            this.connect = false;
            this.makeToast('Sucesso', 'WhatsApp desativado com sucesso!', 'success');
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao desativar o whatsapp!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
 @keyframes btn-pisca {
    0% { opacity: 0; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
 }
.btn-pisca {
  -webkit-animation: btn-pisca .9s linear infinite;
  -moz-animation: btn-pisca .9s linear infinite;
  -ms-animation: btn-pisca .9s linear infinite;
  -o-animation: btn-pisca .9s linear infinite;
  animation: btn-pisca .9s linear infinite;
}
</style>